import axios from 'axios';

const getAuthUrl = async () => {
  const { data } = await axios.get<{ authUrl: string }>('/secrets/authUrl');

  return data;
};

export default getAuthUrl;
